import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss'],
})
export class LicenseComponent {
  constructor(private router: Router) {}

  currentYear = new Date().getFullYear();

  redirectToLogin() {
    this.router.navigate(['']);
  }
}
